/**
 * @Author: Ramkumar <root>
 * @Date:   Jan-24-2017
 * @Email:  raramakrishna@egencia.com
 * @Filename: backbone-overrides.js
 * @Last modified by:   root
 * @Last modified time: Feb-02-2017
 */

;
(function (Backbone, _) {
	'use strict';

	/**
	 * Custom validators to validate model attrbutes
	 */
	_.extend(Backbone.Validation.validators, {

		/**
		 *  This validates whether provided date is a past date or not.
		 *
		 *  Usage:
		 *  validations:    {
		 *  	attributeName: [{
		 *  		pastDate: true
		 *  		msg: 'Value cannot be a future date.'
		 *  	}]
		 *
		 *  }
		 */
		pastDate: function (value, attr, customValue, model) {
			var dateValue;
			if(value)	{
				dateValue = moment(value);
				if(customValue && dateValue > moment())	{
					// Message from validator. This gets overridden if message is specified with validation.
					return attr + "cannot be a future date.";
				}
			}
		},
		futureDate: function (value, attr, customValue, model) {
			var dateValue;
			if(value)	{
				dateValue = moment(value);
				if(customValue && dateValue < moment())	{
					// Message from validator. This gets overridden if message is specified with validation.
					return attr + "cannot be a past date.";
				}
			}
		},
		validateDate: function (value, attr, customValue, model) {
			if (customValue && value === "INVALID_DATE") {
				return attr + "is not a valid date";
			}
		},
		validatePhone: function (value, attr, customValue, model) {
			if (customValue && (value === "INVALID_PHONE" || _.isNaN(value))) {
				return attr + "is not a valid phone number";
			}
		},
		isInvalid: function (value, attr, customValue, model) {
			if (customValue && (value === "INVALID" || _.isNaN(value))) {
				return attr + "is not a valid value";
			}
		},
			pastIssueDate: function (value, attr, customValue, model) {
			var deps,
				$deps,
				$issueDate,
				$expiryDate,
				issueDate,
				expiryDate,
				dateFormat,
				MIN_DATE_DIFF;

			$expiryDate = $('#' + attr);
			dateFormat = 'YYYY-MM-DD';
			MIN_DATE_DIFF = 1;

			if (!$expiryDate.length) {
				return;
			}

			$deps = $expiryDate.closest('.deps');
			deps = $deps.data().deps;

			$issueDate = $(deps.issueDateSelector);

			if(deps.isDropdown) {
				$issueDate = $issueDate.parent().find('.dob-value');
				$expiryDate = $expiryDate.parent().find('.dob-value');
			}

			if (!$issueDate.length) {
				return;
			}

			issueDate = moment($issueDate.val(), dateFormat);
			expiryDate = moment($expiryDate.val(), dateFormat);

			if (!expiryDate.isValid() || !issueDate.isValid()) {
				return;
			}

			if (expiryDate.diff(issueDate, 'days') < MIN_DATE_DIFF) {
				return attr + ' cannot be less than issue date';
			}
		},
		ageValidation: function(value,attr,customValue,model){
		  if(value && (moment().diff(value,'years',false) < customValue)) {
			return 'User cannot be less than'+ customValue+' years';
		  }
		},
		customVal: function (value, attr, customValue, model) {
			if (customValue && (value === "INVALID" || _.isNaN(value))) {
				return customValue;
			}
		}
	});
})(Backbone, _);

